import React, { useState } from 'react';
import './CreateRoutineDialog.css';
import ModalDialog from '../components/Dialog/ModalDialog';
import SearchCard from '../components/SearchCard/SearchCard';
import Banner from '../components/Banner/Banner';
import { RoutineType } from '../types/routine';

interface CreateRoutineDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onCreateRoutine: (routineType: RoutineType) => void;
}

const availableRoutineTypes: RoutineType[] = [
  {
    id: 'post-exercise',
    name: 'Post-Exercise',
    description: 'Skincare routine for after workouts and physical activity',
    icon: 'fitness'
  },
  {
    id: 'back-from-work',
    name: 'Back from Work',
    description: 'Evening routine to remove makeup and workday buildup',
    icon: 'work'
  },
  {
    id: 'beach-day',
    name: 'Beach Day',
    description: 'Special routine for sun protection and post-beach care',
    icon: 'sun'
  },
  {
    id: 'after-night-out',
    name: 'After a Night Out',
    description: 'Late night routine for makeup removal and recovery',
    icon: 'moon'
  }
];

const CreateRoutineDialog: React.FC<CreateRoutineDialogProps> = ({
  isOpen,
  onClose,
  onCreateRoutine
}) => {
  const [selectedRoutineType, setSelectedRoutineType] = useState<RoutineType | null>(null);

  const handleRoutineTypeClick = (routineType: RoutineType) => {
    setSelectedRoutineType(routineType);
  };

  const handleCreateRoutine = () => {
    if (selectedRoutineType) {
      onCreateRoutine(selectedRoutineType);
      setSelectedRoutineType(null);
      onClose();
    }
  };

  const handleClose = () => {
    setSelectedRoutineType(null);
    onClose();
  };

  return (
    <ModalDialog
      isOpen={isOpen}
      onClose={handleClose}
      title="Create New Routine"
      primaryButton={{
        label: "Create Routine",
        onClick: handleCreateRoutine,
        disabled: !selectedRoutineType
      }}
      secondaryButton={{
        label: "Cancel",
        onClick: handleClose
      }}
      maxWidth="800px"
      maxHeight="600px"
    >
      <div className="create-routine-dialog-content">
        <Banner variant="info">
          Choose the type of routine you'd like to create. Each routine type is designed for specific situations and will help you maintain healthy skin in different contexts.
        </Banner>

        <div className="routine-types-grid">
          {availableRoutineTypes.map((routineType) => (
            <SearchCard
              key={routineType.id}
              product={{
                product_id: parseInt(routineType.id.replace(/-/g, '')),
                product_name: routineType.name,
                brand: 'Custom Routine',
                category: 'routine',
                image_url: undefined
              }}
              isSelected={selectedRoutineType?.id === routineType.id}
              onClick={() => handleRoutineTypeClick(routineType)}
            />
          ))}
        </div>
      </div>
    </ModalDialog>
  );
};

export default CreateRoutineDialog;
